import { observer } from 'mobx-react';
import { useEffect } from 'react';

import type ClientsManager from 'stores/ClientsManager';
import store from 'stores/RootStore';

import AddClientButton from '../../UI/AddDocument/AddClientButton';
import DocumentFolderView from '../../UI/DocumentFolderView/DocumentFolderView';

const CLIENTS_VIEW_TITLE = 'Clients';

interface ClientsContentProps {
  clients: ClientsManager;
  documentTitle?: string;
}

function ClientsContent({ clients, documentTitle }: ClientsContentProps) {
  useEffect(() => {
    document.title = documentTitle || CLIENTS_VIEW_TITLE;
  }, [documentTitle]);

  return (
    <DocumentFolderView
      childrenTableTitle="Clients"
      parentDocument={clients}
      childrenTableHeaderButtons={<AddClientButton />}
    />
  );
}

function Clients() {
  return (
    <ClientsContent
      clients={store.clients}
      documentTitle={store.current?.data?.name}
    />
  );
}

export default observer(Clients);
